<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
       id="page-login" v-if="!loadingSettings">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img :src="GetLogoImage"
                   alt="login"
                   class="mx-auto" style="max-width:90%;" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 mb-5">

                <div class="vx-card__title mb-8">
                  <div class="flex justify-between">
                      <h4 >{{$t('Login')}}</h4>
                      <ChangeLanguage class="" style="float:right"></ChangeLanguage>
                  </div>
                    <p v-if="isFirstTimeSetup" class="text-success font-semibold mb-2">
                      {{ $t('WelcomeAdminCreated') }}
                    </p>
                    <p v-if="isFirstTimeSetup" class="text-info mb-2">
                      {{ $t('PleaseLoginWithCredentials') }}
                    </p>
                </div>

                <vs-input v-validate="'required|email|min:3'"
                          name="email"
                          icon="icon icon-user"
                          icon-pack="feather"
                          :label-placeholder="$t('Email')"
                          v-model="email"
                          class="w-full no-icon-border"
                          @keyup="loginOnKey" />
                <!--<span class="text-danger text-sm">
    {{ errors.first("email") }}
  </span>-->

                <vs-input v-validate="'required|min:6|max:50'"
                          type="password"
                          name="password"
                          icon="icon icon-lock"
                          icon-pack="feather"
                          :label-placeholder="$t('Password')"
                          v-model="password"
                          @keyup="loginOnKey"
                          class="w-full mt-6 no-icon-border" />
                <span class="text-danger text-sm">
                  {{  errors.first("password") }}
                </span>

                <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me" class="mb-3">{{$t('RememberMe')}}</vs-checkbox>
                  <router-link to="/pages/forgot-password">{{$t('ForgotPassword')}}?</router-link>
                </div>
                <vs-button class="mr-5" type="border" @click="registerUser" v-if="this.$systemSettings && this.$systemSettings.AllowRegistration">{{$t('Register')}}</vs-button>

                <!-- Standard Login Button -->
                <vs-button style="background:green"
                           class="auth-button mt-5"
                           @click="login">{{$t('Login')}}</vs-button>

                <div v-if="loginProviders && loginProviders.length > 0" class="my-5">
                  <vs-divider>OR</vs-divider>
                  <!-- Social Login Buttons -->
                  <div class="social-login-buttons flex flex-wrap items-center mt-4">
                    <!-- LinkedIn Button with appropriate styling -->
                    <vs-button 
                      v-for="provider in loginProviders" 
                      :key="provider.ProviderName"
                      :class="['social-login-btn', provider.ProviderName === 3 ? 'linkedin-btn' : '']"
                      @click="loginWith(provider.ProviderName)">
                      <!-- LinkedIn Icon for LinkedIn Provider -->
                      <template v-if="provider.ProviderName === 3">
                        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                        </svg>
                        {{provider.Title}}
                      </template>
                      <!-- Default for other providers -->
                      <template v-else>
                        {{provider.Title}}
                      </template>
                    </vs-button>
                  </div>
                </div>

                <!-- <vs-divider>OR</vs-divider> -->

                <div v-if="false"
                     class="social-login flex flex-wrap justify-between">
                  <div v-show="false"
                       class="social-login-buttons flex flex-wrap items-center mt-4">
                    <!-- facebook -->
                    <div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                         @click="loginWithFacebook">
                      <svg aria-hidden="true"
                           focusable="false"
                           data-prefix="fab"
                           data-icon="facebook-f"
                           class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
                           role="img"
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 264 512">
                        <path fill="currentColor"
                              d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"></path>
                      </svg>
                    </div>

                    <!-- TWITTER -->
                    <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                         @click="loginWithTwitter">
                      <svg aria-hidden="true"
                           focusable="false"
                           data-prefix="fab"
                           data-icon="twitter"
                           class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16"
                           role="img"
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 512 512">
                        <path fill="currentColor"
                              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                      </svg>
                    </div>

                    <!-- GOOGLE -->
                    <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                         @click="loginWithGoogle">
                      <svg aria-hidden="true"
                           focusable="false"
                           data-prefix="fab"
                           data-icon="google"
                           class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16"
                           role="img"
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 488 512">
                        <path fill="currentColor"
                              d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path>
                      </svg>
                    </div>

                    <!-- GITHUB -->
                    <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                         @click="loginWithGithub">
                      <svg aria-hidden="true"
                           focusable="false"
                           data-prefix="fab"
                           data-icon="github-alt"
                           class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15"
                           role="img"
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 480 512">
                        <path fill="currentColor"
                              d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"></path>
                      </svg>
                    </div>
                  </div>
                  <!-- <vs-button class="mt-4" @click="loginAuth0" color="#eb5424">Auth0</vs-button> -->
                  <!--<vs-button class="mt-4" @click="loginAuth0" color="#eb5424">KAUST ID</vs-button>-->
                </div>
              </div>
            </div>
          </div>

        </div>
      </vx-card>
    </div>
   
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';
  import AccountsService from '@/accounts/accountsService.js';
  import ChangeLanguage from '@/views/components/extra-components/language/ChangeLanguage.vue';

  export default {
    data() {
      return {
        email: "",
        password: "",
        checkbox_remember_me: false,
        loggingIn: false,
        ldapSettings: null,
        loginProviders: null,
        brandSettings: null,
        loadingSettings: true,
        isFirstTimeSetup: false
      };
    },
    components: {
      ChangeLanguage
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.email != "" && this.password != "";
      },
      GetLogoImage() {
        var requiredImage = require('@/assets/images/pages/login.png');
        return this.brandSettings && this.brandSettings.LoginLogoUrl ? this.brandSettings.LoginLogoUrl : requiredImage;
      }
    },
    methods: {
      loginOnKey(evt) {
        if (evt.keyCode == 13)
          this.login();
      },
      login() {
        this.loginWith(1); // Default Provider
      },
      loginWithLdap() {
        this.loginWith(2); // LDAP.
      },

      loginWith(provider) {
        if (!provider)
          provider = provider;

        var instance = this;

        // Special handling for LinkedIn (provider 3)
        if (provider === 3 || provider === 'LinkedIn') {
          // Display loading notification
          this.$vs.notify({
            title: this.$t("LinkedInAuthentication"),
            text: this.$t("ConnectingToLinkedIn"),
            iconPack: "feather",
            icon: "icon-info",
            color: "primary"
          });
          
          // Get LinkedIn authorization URL from server
          TCVelikClient.GetRelative("/api/Accounts/LinkedInAuthUrl")
            .then(response => {
              console.log("LinkedIn auth URL response:", response);
              // Axios response has data property
              if (response && response.data && response.data.authUrl) {
                console.log("LinkedIn auth URL:", response.data.authUrl);
                // Open LinkedIn auth in a popup
                const width = 600;
                const height = 600;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                const popup = window.open(
                  response.data.authUrl,
                  'LinkedIn Login',
                  `width=${width},height=${height},left=${left},top=${top}`
                );
                
                // Listen for message from popup
                window.addEventListener('message', (event) => {
                  if (event.origin === window.location.origin) {
                    if (event.data && event.data.Response) {
                      localStorage.setItem(location.hostname + "-token", event.data.Response.token);
                      AccountsService.refreshUser().then(function () {
                        instance.$nextTick(function () {
                          window.location.href = '/pages/home';
                        });
                      });
                    }
                  }
                });
              } else {
                console.error("LinkedIn auth URL not provided in response:", response);
                this.$vs.notify({
                  title: this.$t("LoginFailed"),
                  text: this.$t("LinkedInAuthNotConfigured"),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger"
                });
              }
            })
            .catch(error => {
              console.error("LinkedIn auth error:", error);
              // More detailed error message
              let errorMessage = this.$t("CannotConnectLinkedIn");
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error("Error response:", error.response.data);
                console.error("Error status:", error.response.status);
                errorMessage += ` Status: ${error.response.status}`;
              } else if (error.request) {
                // The request was made but no response was received
                console.error("Error request:", error.request);
                errorMessage += " No response received.";
              } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Error message:", error.message);
                errorMessage += ` Message: ${error.message}`;
              }
              
              this.$vs.notify({
                title: this.$t("LoginFailed"),
                text: errorMessage,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
            });
          
          return; // Exit early, don't proceed with normal login flow
        }

        // Normal login flow for other providers
        this.$set(this, "loggingIn", true);
        this.$acl.change("admin");

        localStorage.removeItem("userRole");
        localStorage.removeItem(location.hostname + "-userInfo");
        localStorage.removeItem(location.hostname + '-fullUserInfo');
        
        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          userDetails: {
            email: this.email,
            password: this.password,
            provider: provider
          },

          notify: this.$vs.notify,
        };

        this.$store.dispatch("auth/loginAttempt", payload);
        this.$set(this, "loggingIn", false);
      },

      loginAuth0() {
        if (this.$store.state.auth.isUserLoggedIn()) {
          this.notifyAlreadyLogedIn();
          return false;
        }
        this.$auth.login({ target: this.$route.query.to });
      },

      // Google login
      loginWithGoogle() {
        this.$store.dispatch("auth/loginWithGoogle", { notify: this.$vs.notify });
      },

      // Facebook login
      loginWithFacebook() {
        this.$store.dispatch("auth/loginWithFacebook", {
          notify: this.$vs.notify,
        });
      },

      // Twitter login
      loginWithTwitter() {
        this.$store.dispatch("auth/loginWithTwitter", {
          notify: this.$vs.notify,
        });
      },

      // Github login
      loginWithGithub() {
        this.$store.dispatch("auth/loginWithGithub", { notify: this.$vs.notify });
      },

      notifyAlreadyLogedIn() {
        this.$vs.notify({
          title: this.$t("LoginAttempt"),
          text: this.$t("AlreadyLoggedIn"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      },

      registerUser() {
        //if (this.$store.state.auth.isUserLoggedIn()) {
        //  this.notifyAlreadyLogedIn();
        //  return false;
        //}
        this.$router.push("/pages/register");
      },
    },
    mounted() {
      var instance = this;

      // Check if this is a first-time setup
      this.isFirstTimeSetup = this.$route.query.firstTimeSetup === 'true';

      const redirectUri = this.$route.query.redirect_uri;
      const returnUrl = this.$route.query.returnUrl;
      const token = localStorage.getItem(location.hostname + '-token');

      if (redirectUri && token) {
        // SSO: If already logged in, immediately send token and close
        if (window.opener) {
          window.opener.postMessage({ type: 'LOGIN_TOKEN', token }, '*');
          window.close();
        } else {
          if (returnUrl) {
            window.location.href = `${redirectUri}`;
          }
          else {
            window.location.href = `${redirectUri}?token=${encodeURIComponent(token)}`;
          }
        }
        return; // Prevent further navigation!
      }

      try {
        TCVelikClient.GetRelative("/api/accounts/welcome").then(function (resp) {
          if (resp && resp.data) {
            try {
              instance.loginProviders = resp.data.LoginSettings;
              instance.brandSettings = JSON.parse(resp.data.AccountSettings);
              instance.loadingSettings = false;
            }
            catch (err) {
              instance.loadingSettings = false;
            }
          }
        });
      }
      catch (err) {
        instance.loadingSettings = false;
      }
    }
  };
</script>

<style>
  /* Default (small screens) */
  .auth-button {
    width: 100%;
  }

  /* Social login buttons */
  .social-login-btn {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  /* LinkedIn specific styling */
  .linkedin-btn {
    background-color: #0077b5 !important;
    color: white !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Large screens (e.g., min-width: 768px or 992px, depending on your needs) */
  @media screen and (min-width: 768px) {
    .auth-button {
      width: auto !important;
      margin-right:2em;
    }
  }
</style>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
